import { Component, OnInit } from "@angular/core";
import { ThemeService } from "./core/services/theme.service";
import { WhiteLabelService } from "./core/services/whitelabel.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private themeService: ThemeService,
    public wl: WhiteLabelService,
  ) {}

  ngOnInit() {}
}
